const grey400Color = '#D8DCDE';

export default grey400Color;
